import { classNameMerger } from '@breetometer/utils';
import Lottie from 'lottie-react';

import defaultAnimationData from '@/assets/lottie/loading.json';

const Loader = ({ animationData, bgClassName }: { animationData?: unknown; bgClassName?: string }) => (
	<div
		className={classNameMerger('bt_baseLoader', bgClassName ?? 'bg-primary-700')}
		data-testid='loader'
	>
		<Lottie animationData={animationData ?? defaultAnimationData} />
	</div>
);

export default Loader;
